// extracted by mini-css-extract-plugin
export var content = "product-module--content--xvCtB";
export var descriptionBox = "product-module--description-box--PvTlW";
export var layout = "product-module--layout--DfvuV";
export var related = "product-module--related--a9fyx";